<script>
    import { client, locale, isMobile } from "../stores.js";

    import { getLocaleResource } from "../utils/locales.js";
</script>

<div class="container">
    <div class="header">
        {#if $client}
            <a href="/user">
                <div class="item shadow">
                    {$client.companyKey} - {$client.companyName}
                </div>
            </a>

            <a href="/orders">
                <div class="item">
                    <b>{getLocaleResource($locale, "orders")}:</b>
                    {$client.orders}
                </div>
            </a>

            <a href="/invoices">
                <div class="item shadow">
                    <b>{getLocaleResource($locale, "invoices")}:</b>
                    {$client.invoices}
                </div>
            </a>

            <a href="/finance">
                <div class="item shadow">
                    <b>{getLocaleResource($locale, "dueAmount")}:</b>
                    {$client.dueAmount?.toLocaleString() || 0} KM
                </div>
            </a>
        {/if}
    </div>

    <div class="body">
        <a
            href="/sale"
            class="category shadow"
            style={`width: 100%; ${$isMobile ? "height: auto;" : ""}`}
        >
            <img
                src="/sale_banner.jpg"
                alt=""
                style="width: 100%; height: auto;"
            />
        </a>

        <a href="/products?category=Ceiling%20Lights" class="category shadow">
            <div class="label">Ceiling Lights</div>
            <img src="/ceiling_lights.jpg" alt="" />
        </a>

        <a href="/products?category=Pendant%20Lights" class="category shadow">
            <div class="label">Pendant Lights</div>
            <img src="/pendant_lights.jpg" alt="" />
        </a>

        <a href="/products?category=Outdoor%20Lights" class="category shadow">
            <div class="label">Outdoor Lights</div>
            <img src="/outdoor_lights.jpg" alt="" />
        </a>

        <a href="/products?category=Spotlights" class="category shadow">
            <div class="label">Spotlights</div>
            <img src="/spotlights.jpg" alt="" />
        </a>

        <a href="/products?category=Table%20Lamps" class="category shadow">
            <div class="label">Table Lamps</div>
            <img src="/table_lamps.jpg" alt="" />
        </a>

        <a href="/products?category=Floor%20Lamps" class="category shadow">
            <div class="label">Floor Lamps</div>
            <img src="/floor_lamps.jpg" alt="" />
        </a>

        <a href="/products?category=Bulbs" class="category shadow">
            <div class="label">Bulbs</div>
            <img src="/bulbs.jpg" alt="" />
        </a>

        <a href="/products?category=Wall%20Lights" class="category shadow">
            <div class="label">Wall Lights</div>
            <img src="/wall_lights.jpg" alt="" />
        </a>

        <a href="/products?category=Decorative%Lights" class="category shadow">
            <div class="label">Decorative Lights</div>
            <img src="/decor.jpg" alt="" />
        </a>

        <a href="/products?category=Traditional" class="category shadow">
            <div class="label">Traditional</div>
            <img src="/traditional.jpg" alt="" />
        </a>

        <a href="/products?category=Fans" class="category shadow">
            <div class="label">Fans</div>
            <img src="/fans.jpg" alt="" />
        </a>

        <a href="/products?category=Chandelier" class="category shadow">
            <div class="label">Chandelier</div>
            <img src="/chandelier.jpg" alt="" />
        </a>

        <a href="/products?category=Solar%20Lights" class="category shadow">
            <div class="label">Solar Lights</div>
            <img src="/solar_lights.jpg" alt="" />
        </a>

        <!-- <a href="/products?category=Recessed%20Spotlig" class="category shadow">
            <div class="label">Recessed Spotlights</div>
            <img src="/solar_lights.jpg" alt="" />
        </a>

        <a href="/products?category=Other" class="category shadow">
            <div class="label">Other</div>
            <img src="/solar_lights.jpg" alt="" />
        </a> -->
    </div>
</div>

<!-- 
    <div class="body">
        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/09/visilice-lusteri.jpg"
                    alt=""
                />
            </a>
        </div>

        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/09/plafonjere.jpg"
                    alt=""
                />
            </a>
        </div>

        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/09/stolne-lampe.jpg"
                    alt=""
                />
            </a>
        </div>

        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/09/ventilatori.jpg"
                    alt=""
                />
            </a>
        </div>

        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/09/podne-lampe.jpg"
                    alt=""
                />
            </a>
        </div>

        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/09/solarna-rasvjeta.jpg"
                    alt=""
                />
            </a>
        </div>

        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/09/zidna-rasvjeta.jpg"
                    alt=""
                />
            </a>
        </div>

        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/09/vanjska-rasvjeta.jpg"
                    alt=""
                />
            </a>
        </div>

        <div class="category">
            <a href="/products?category=Ceiling%20Lights">
                <img
                    src="https://globo-lighting.ba/wp-content/uploads/2021/10/smart-rasvjeta.jpg"
                    alt=""
                />
            </a>
        </div>
    </div>

-->
<style>
    .container {
        display: grid;
        grid-template-rows: 50px calc(100vh - 100px);
        padding: 20px;
    }

    .header {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        margin-bottom: 20px;
        align-items: center;
    }

    .item {
        background: white;
        padding: 10px;
        display: flex;
        align-items: center;
        border-radius: 5px;
    }

    .item a {
        color: rgb(66, 66, 233);
        text-decoration: underline;
    }

    .item b {
        margin-right: 10px;
    }

    .body {
        display: flex;
        align-content: flex-start;
        justify-content: space-between;

        flex-wrap: wrap;
        gap: 20px;
    }

    .category {
        position: relative;
        width: 300px;
        height: 100px;

        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        background: rgba(0, 0, 0, 0.6);
        padding: 10px;
        color: white;
    }

    img {
        flex-shrink: 0;
        max-width: 100%;
    }

    @media only screen and (max-device-width: 600px) {
        .container {
            grid-template-rows: 180px calc(100vh - 200px);
            overflow: auto;
            padding: 0px;
        }

        .header {
            flex-wrap: wrap;
            gap: 10px;
            padding: 10px;
        }

        .category {
            width: 100%;
        }

        .body {
            justify-content: center;
            padding: 10px;
        }
    }
</style>
